import { postApi } from '../../../utils/api'

import { CONNECTED_REQUEST_FILTER_KEY } from './RequestProfileTabAttachedRequests.constants'

export function getRelatedRequestsTotalCount({ requestId }) {
  return postApi({
    data: {
      filters: { [CONNECTED_REQUEST_FILTER_KEY]: [requestId] },
    },
    endpoint: 'idwell-api/api/v3/request/requests/filter/total/',
  })
}
